import React from 'react';
import { useNavigate } from 'react-router-dom';
import Features from './Features';
import './Hero.scss';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="hero-background">
        <img 
          src="/assets/IMG/fond.jpeg" 
          alt="Background" 
          className="bg-image"
        />
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-text">
              <h1 className="hero-title">
                <span className="title-line">Etudiants Africains:</span>
                <span className="title-line highlight">Valorisez votre présent, Bâtissez votre avenir.</span>
              </h1>
              
              <p className="hero-subtitle">
                Découvrez des ressources exclusives, un mentorat de qualité et des 
                opportunités pour exceller dans vos études supérieures 
                à travers l'Afrique. Rejoignez une communauté dévouée à votre succès.
              </p>

              <button className="hero-cta" onClick={() => navigate('/inscription')}>
                Commencer Maintenant
              </button>
            </div>
            
            <Features />
          </div>

          <div className="hero-image">
            <div className="image-card">
              <img 
                src="/assets/IMG/etudiants.png" 
                alt="Étudiants africains" 
                className="students-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
